// Dynamic styles based on theme - to be used with useThemedStyles.
export const createMyLeaveRequestViewStyles = ({ ui: { colors, radius, space, touch, type } }) => ({
	group: {
		gap: 6,
	},
	row: {
		flexDirection: 'row',
		gap: space.sm,
	},
	rowItem: {
		flex: 1,
	},
	label: {
		...type.fieldLabel,
		color: colors.text,
	},
	balanceText: {
		...type.secondary,
		color: colors.textSecondary,
	},
	footnote: {
		...type.caption,
		color: colors.textFaint,
	},
	notice: {
		padding: space.md,
	},
	noticeText: {
		...type.secondary,
		color: colors.warning,
	},
	switchCard: {
		paddingHorizontal: 14,
	},
	repeatFields: {
		gap: space.md,
		paddingBottom: 14,
	},
	weekdays: {
		flexDirection: 'row',
		gap: space.xs,
	},
	// Seven equal chips on one row (about 43 wide on a 390 phone).
	weekday: {
		flex: 1,
		minHeight: touch.min,
		borderRadius: radius.card,
		borderWidth: 1,
		borderColor: colors.borderStrong,
		backgroundColor: colors.raised,
		alignItems: 'center',
		justifyContent: 'center',
	},
	weekdaySelected: {
		borderColor: colors.primary,
		backgroundColor: colors.primary,
	},
	pressed: {
		opacity: 0.85,
	},
	weekdayLabel: {
		...type.bodySmallStrong,
		color: colors.text,
	},
	weekdayLabelSelected: {
		color: colors.onPrimary,
	},
	helperText: {
		...type.secondary,
		color: colors.textSecondary,
	},
	notesInput: {
		minHeight: 100,
		marginBottom: 0,
	},
	errorText: {
		...type.bodySmall,
		color: colors.danger,
	},
});
